import { useState } from "react";
import PropTypes from "prop-types";
import { ALLink as Link } from "../ALComponents";
import IconArrow from "../icons/svgs/arrow.svg";

function FooterItem({ footerLink }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasNestedLinks = footerLink?.links && footerLink?.links.length > 0;

  const toggleExpanded = () => {
    setIsExpanded((prevState) => !prevState);
  };

  if (footerLink.title?.toLowerCase() === "empty") {
    return null;
  }

  if (hasNestedLinks) {
    return (
      <li className="footer_collapsible" key={`footer_item_link_${footerLink.title}`}>
        <button
          className="flex justify-between text-left items-center cursor-pointer typo-micro text-black cursor-pointer hover:underline mobile:typo-body"
          onClick={toggleExpanded}
          aria-expanded={isExpanded}
          aria-controls={`submenu_${footerLink.title}`}
          type="button"
        >
          {footerLink?.title}{" "}
          <IconArrow
            style={{
              transform: isExpanded ? "rotate(90deg)" : "rotate(270deg)",
              marginLeft: "10px",
              transition: "transform 300ms linear",
            }}
            width="7"
            height="14"
          />
        </button>
        <ul
          id={`submenu_${footerLink.title}`}
          className={`flex flex-col gap-[12px] max-h-0 overflow-hidden transition-all duration-200 ease-linear pl-0 [&.expanded]:h-auto [&.expanded]:max-h-[400px] [&.expanded]:overflow-hidden [&.expanded]:duration-300 ${
            isExpanded ? "expanded mt-[15px] mobile:mt-[18px]" : "mt-0"
          }`}
          role="menu"
        >
          {footerLink.links.map((nestedLink) => (
            <FooterItem key={`footer_subitem_${nestedLink.title}`} footerLink={nestedLink} />
          ))}
        </ul>
      </li>
    );
  }

  const isExternal = footerLink?.link?.link?.startsWith("http");
  return (
    <li className="flex" key={`footer_item_link_${footerLink.title}`}>
      {isExternal ? (
        <a
          href={footerLink?.link?.link}
          className="typo-micro text-black mobile:typo-body"
          title={footerLink?.title}
          rel="noopener noreferrer"
        >
          {footerLink?.title}
        </a>
      ) : (
        <Link
          className="typo-micro text-black mobile:typo-body"
          to={footerLink?.link?.link}
          title={footerLink?.title}
        >
          {footerLink?.title}
        </Link>
      )}
    </li>
  );
}

FooterItem.propTypes = {
  footerLink: PropTypes.shape({
    title: PropTypes.string.isRequired,
    link: PropTypes.shape({
      link: PropTypes.string,
    }),
    links: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        link: PropTypes.shape({
          link: PropTypes.string.isRequired,
        }),
      })
    ),
  }).isRequired,
};

export default FooterItem;
